<div class="row subject-div">
  <div class="col s3 m3 l3 xl3">
    <div class="custom-padding">
      <span><span class="bold">Subject:</span></span>
    </div>
  </div>
  <div class="col s9 m9 l9 xl9">
    <div class="custom-padding">
      <span>{{setSubject}}</span>
    </div>
  </div>
</div>
<div class="row topic-div">
  <div class="col s3 m3 l3 xl3">
    <span><span class="bold">Topic:</span></span>
  </div>
  <div class="col s9 m9 l9 xl9">
    <span>{{setTopic}}</span>
  </div>
</div>
<div class="row body-row message-div">
  <div class="col s12 m3 l3 xl3">
    <div class="message-body">
      <span class="bold">Message:</span>
    </div>
  </div>
  <div class="col s12 m9 l9 xl9 align-left right-padding-0 body-height">
    <div *ngIf="reply">
      <textarea name="messageVal" kendoTextArea placeholder="Enter message" [autoSize]="true" [maxlength]="maxLength"
        class="full-width text-area-height" id="body-text" [(ngModel)]="messageVal"></textarea>
      <div class="align-right">
        <span *ngIf="messageVal" class="word-count">{{messageVal.length}}/{{maxLength}}</span>
      </div>
    </div>
    <div class="previous-messages">
      <span>
        {{origMsg}}
      </span>
    </div>
  </div>
</div>
<div *ngIf="!deletedMsg" class="row margin-bottom-0">
  <div class="col s12 m12 l12 xl12 align-center">
    <button *ngIf="showReply" class="btn waves-effect background-red waves-light custom-margin" id="reply-btn"
      (click)="replyMessage()" primary="true">Reply</button>
    <button *ngIf="reply" [disabled]="isDisabled()" class="btn waves-effect background-red waves-light custom-margin" id="send-btn"
      (click)="sendMessage()" primary="true">Send</button>
  </div>
</div>
